import request from '@/utils/request'

/**
 * 模板列表
 * @param {Object} [params] 查询参数，如 { templateCategory: '经营分析' | '市场洞察' }
 * @returns {Promise}
 */
export function getTemplateList(params) {
  return request({
    url: '/eiip-ai/template/list',
    method: 'get',
    params
  })
}
export function getTemplateDetail(id) {
  return request({
    url: `/eiip-ai/template/external?id=${id}`,
    method: 'get'
  })
}
export function createReportTitle(data) {
  return request({
    url: `/eiip-ai/report/generate`,
    method: 'post',
    data
  })
}

/**
 * 企业模糊搜索（按名称分页查询）
 * @param {String} keywords 企业名称关键词
 * @param {Object} [extra] 额外参数，如 { pageNo, pageSize }
 * @returns {Promise}
 */
export function searchEnterpriseByName(keywords, extra = {}) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/page-by-name',
    method: 'get',
    params: { keywords, pageNo: 1, pageSize: extra.pageSize || 10, ...extra }
  })
}

/**
 * 企业精确查询（基本信息）
 * @param {String} enterpriseName 企业全称
 * @returns {Promise}
 */
export function getEnterpriseBasicInfo(enterpriseName) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/basic',
    method: 'get',
    params: { enterpriseName }
  })
}

/**
 * 查询企业股东信息（分页）
 * @param {String} enterpriseId 企业ID
 * @param {Object} [extra] 额外分页参数，如 { pageNo: 1, pageSize: 10 }
 * @returns {Promise}
 */
export function getEnterpriseShareholders(enterpriseId, extra = {}) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/shareholders',
    method: 'get',
    params: { enterpriseId, ...extra }
  })
}

/**
 * 企业招投标分页查询
 * @param {Object} params { enterpriseId, type(100招标方/200投标方/300代理方/400被提及), titleKeyword, pageNo, pageSize }
 * @returns {Promise}
 */
export function getEnterpriseBids(params) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/bids',
    method: 'get',
    params
  })
}

/**
 * 招投标公告详情
 * @param {Object} params { id(列表返回的详情ID), type(100招标方/200投标方/300代理方/400被提及), companyId(被查询企业ID), platformCode? }
 * @returns {Promise}
 */
export function getEnterpriseBidDetail(params) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/bid/detail',
    method: 'get',
    params
  })
}

/**
 * 查询参数序列化：condition JSON 中的 { } [ ] " 等特殊字符必须百分号编码，
 * 否则后端按字面量解析 URL 会返回 400（axios 默认序列化保留方括号）。
 */
function serializeJsonParams(params) {
  const search = new URLSearchParams()
  Object.keys(params || {}).forEach((key) => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, value)
    }
  })
  return search.toString()
}

/**
 * 企业多条件分页查询（企业画像筛选）
 * @param {Object} params { condition(JSON字符串), pageNo, pageSize, platformCode? }
 * @returns {Promise}
 */
export function getEnterpriseByMultiCondition(params) {
  return request({
    url: '/eiip-ai/enterprise-data/enterprise/page-by-multi-condition',
    method: 'get',
    params,
    paramsSerializer: serializeJsonParams
  })
}
